import { useQueryState } from '@dustin-web/microsite-components/src/hooks'
import error from 'next/error'
import { useEffect, useState } from 'react'

import { ProductReferenceFragment } from '@productsite/src/graphql/generated/graphql-types'

type InfinityScrollRenderedPage = {
  products: ProductReferenceFragment[]
  pageInUrl: number
}

type Props = {
  products: ProductReferenceFragment[]
}
export const infinityScrollPageSize = 18

export const findProductsInInfinityScrollPages = (
  infinityScrollPages: InfinityScrollRenderedPage[]
): ProductReferenceFragment[] => {
  const products = [] as ProductReferenceFragment[]
  infinityScrollPages.map(item => {
    item?.products?.forEach(product => {
      if (
        !products.find(existing => {
          return existing.id === product.id
        })
      ) {
        products.push(product)
      }
    })
  })
  return products
}

/** @deprecated This hook will be removed in future releases. Use `useInfiniteProducts` hook instead */
export const useInfinityScroll = ({ products }: Props) => {
  const { queryState } = useQueryState()
  const [renderedPages, setRenderedPages] = useState<InfinityScrollRenderedPage[]>([
    { pageInUrl: queryState.page, products: products },
  ] as InfinityScrollRenderedPage[])

  // The parent component (search.tsx) fetches the current page on initial load.
  // Subsequent "View More" clicks fetch only the next page incrementally.
  // Previous pages are fetched in the background and prepended.
  useEffect(() => {
    const existingViewPagePage = renderedPages.find(e => {
      return e.pageInUrl === queryState.page
    })
    if (existingViewPagePage === undefined) {
      if (products) {
        setRenderedPages([...renderedPages, { pageInUrl: queryState.page, products: products }])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products])

  //When filter changes, page is always set to 1 again. - clear infinityScrollPages.
  useEffect(() => {
    if (products && queryState.page === 1) {
      setRenderedPages([{ pageInUrl: queryState.page, products: products }])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryState.activeFilters.length, products])

  // Add a previous page to the list (called by background fetch logic)
  const addPreviousPage = (pageNum: number, pageProducts: ProductReferenceFragment[]) => {
    setRenderedPages(prev => {
      if (prev.find(p => p.pageInUrl === pageNum)) return prev
      return [...prev, { pageInUrl: pageNum, products: pageProducts }]
    })
  }

  // Sort pages by number before flattening so products appear in correct order
  const sortedPages = [...renderedPages].sort((a, b) => a.pageInUrl - b.pageInUrl)
  const productsToShow = findProductsInInfinityScrollPages(sortedPages)

  return {
    error,
    productsToShow,
    addPreviousPage,
  }
}

export default useInfinityScroll
